import { EmploymentHistoryEntry } from '../../components/Questions/CardlessEmploymentHistoryQuestion/EmploymentHistoryContext'
import { EmploymentSituation, mapEmploymentSituation } from '../EmploymentSituationMapper'

export interface EmploymentField {
  occupationField: string
  employerNameField: string
  yearsField: number
  monthsField: number
  employmentAddressField: {
    townCityField: string
  },
  employmentStatusField: EmploymentSituation
  netMonthlyIncomeField: number
  employmentOrderField: number
}

const getOccupation = (entry: EmploymentHistoryEntry): string => {
  if (entry.employerDetails?.jobTitle) {
    return entry.employerDetails.jobTitle
  }
  return entry.employmentSituation || ''
}

const getEmployerName = (entry: EmploymentHistoryEntry): string => {
  if (entry.employerDetails?.companyName) {
    return entry.employerDetails.companyName
  }
  return entry.employmentSituation || ''
}

const mapToEmploymentForm = (
  employmentEntry: EmploymentHistoryEntry,
  income: number,
  currentTown: string,
  index: number
): EmploymentField => ({
  occupationField: getOccupation(employmentEntry),
  employerNameField: getEmployerName(employmentEntry),
  yearsField: employmentEntry.lengthOfTime?.years
    ? parseInt(employmentEntry.lengthOfTime.years, 10) : 0,
  monthsField: employmentEntry.lengthOfTime?.months
    ? parseInt(
      employmentEntry.lengthOfTime.months,
      10
    ) : 0,
  employmentAddressField: {
    townCityField: currentTown
  },
  employmentStatusField: mapEmploymentSituation(employmentEntry.employmentSituation || ''),
  netMonthlyIncomeField: index === 0 ? income : 0,
  employmentOrderField: index + 1
})

export default mapToEmploymentForm
